import { useEffect, useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coldarkDark as highlight } from "react-syntax-highlighter/dist/cjs/styles/prism";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

export default function Markdown({ content }) {
  const [text, setText] = useState("");
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    Promise.resolve(fetch(content))
      .then((response) => {
        response.text().then(setText);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [content]);

  const customStyle = {
    fontFamily:
      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    backgroundColor: "#1f2937",
  };

  const generateSlug = (str) => {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  if (isLoading) {
    const antIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />;
    return <Spin indicator={antIcon} />;
  }

  return (
    <ReactMarkdown
      className="prose !max-w-5xl !w-full"
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      components={{
        h3: (props) => {
          const children = Array.isArray(props.children)
            ? props.children
            : [props.children];
          const heading = children
            .flatMap((element) =>
              typeof element === "string"
                ? element
                : element?.type !== undefined &&
                  typeof element.props.children === "string"
                  ? element.props.children
                  : [],
            )
            .join("");

          const slug = generateSlug(heading);

          return <h3 id={slug} className="scroll-mt-24" {...props} />;
        },
        code(props) {
          const { children, className, node, ...rest } = props;
          const match = /language-(\w+)/.exec(className || "");
          if (!match) {
            return (
              <code className="!bg-white color-black" {...rest}>
                {children}
              </code>
            );
          }
          return (
            <SyntaxHighlighter
              {...rest}
              PreTag="div"
              children={String(children).replace(/\n$/, "")}
              language={match[1]}
              customStyle={customStyle}
              style={highlight}
            />
          );
        },
      }}
    >
      {text}
    </ReactMarkdown>
  );
}